import { PROXY_URL } from "./config";
import { getSession } from "./authApi";

// Asks the Worker to create a scan (job, run and samples).
// Returns { jobId } or { error }.
export async function startScan(scan) {
  try {
    const session = await getSession();
    const res = await fetch(`${PROXY_URL}/start-scan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session?.access_token || ""}`,
      },
      body: JSON.stringify(scan),
    });
    const text = await res.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      console.error(`start-scan returned non-JSON (status ${res.status}): ${text.slice(0, 300)}`);
    }
    if (!res.ok || !data?.jobId) return { error: data?.error || `Status ${res.status}` };
    return { jobId: data.jobId };
  } catch (e) {
    console.error(e);
    return { error: "Couldn't reach the search service" };
  }
}

// Asks the Worker to start a job straight away.
export async function startJobNow(jobId) {
  try {
    const session = await getSession();
    await fetch(`${PROXY_URL}/run-job`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session?.access_token || ""}`,
      },
      body: JSON.stringify({ jobId }),
    });
  } catch (e) {
    console.error(e);
    // Not fatal - the scheduled Worker will pick this job up within a minute regardless.
  }
}
